import React, { useState } from "react";
import logo from "../../assets/images/acumenVelocityLogo.svg";
import { Image } from "react-bootstrap";
import { TiTick } from "react-icons/ti";

export const SelectVersion = () => {
    const [selectedVersion, setSelectedVersion] = useState("")

    return (
        <div
            className="min-vh-100 d-flex flex-column"
            style={{ backgroundColor: "#E9EEF7" }}
        >
            <div
                className="d-flex align-items-center cursor_pointer p-2"
                style={{ height: "8vh" }}
            >
                <Image alt="logo" src={logo} height={40} className="mx-2" />
                <p className="name fs_18 fw_600 m-0">Acumen Translation Hub</p>
            </div>
            <div className="flex-grow-1 d-flex justify-content-center align-items-center fn_Roboto">
                <div className="bg-light d-flex flex-column flex-md-row justify-content-center align-items-center p-4 rounded-3 mx-2 mx-md-5 gap-2 col-12 col-md-8 col-lg-6">
                    <div className="w-100 w-md-50 p-3">
                        <p className='fn_Roboto text_title fs_28 fs_sm_18'>Acumen Translation Hub</p>
                        <p className="fs_14 sub_title">
                            Make your documents multilingual with a single click. Translate
                            from 1 to many languages in a single step!
                        </p>
                        <ul className="list-unstyled fs_14 fn_google_sans">
                            <li className="d-flex align-items-center">
                                <TiTick style={{ color: "#3995E7" }} className="me-2" />
                                <span>Fast translation for PDF’s, Word and Powerpoints</span>
                            </li>
                            <li className="d-flex align-items-center">
                                <TiTick style={{ color: "#3995E7" }} className="me-2" />
                                <span>Full format retention</span>
                            </li>
                            <li className="d-flex align-items-center">
                                <TiTick style={{ color: "#3995E7" }} className="me-2" />
                                <span>Customize translations with your own models or</span>
                            </li>
                            <li className="d-flex align-items-center">
                                <TiTick style={{ color: "#3995E7" }} className="me-2" />
                                <span>Use Google's Neural Machine Translation model</span>
                            </li>
                            <li className="d-flex align-items-center">
                                <TiTick style={{ color: "#3995E7" }} className="me-2" />
                                <span>Single, transparent pricing</span>
                            </li>
                        </ul>
                    </div>
                    <div className="w-100 w-md-50 p-4 mt-4 mt-md-0 border rounded">
                        <p className="fs-5 fw-normal text-black text-center">
                            Please Select Your Version to Continue In<br />
                            Acumen Translation Hub
                        </p>

                        <div className="text-start mb-3">
                            <label htmlFor="version" className="form-label">Select Version</label>
                            <select
                                id="version"
                                name="version"
                                className="input-field w-100"
                                aria-label="Select version"
                                value={selectedVersion}
                                onChange={(e) => setSelectedVersion(e.target.value)}
                                onClick={(e) => setSelectedVersion(e.target.value)}
                            >
                                <option value="" disabled>Select Version</option>
                                <option value="basic">Basic</option>
                                <option value="pro">Pro</option>
                            </select>
                        </div>
                        <div className="d-flex justify-content-between mt-3">
                            <button
                                className="btn btn-primary"
                                onClick={() => setSelectedVersion("")}
                            >
                                Clear
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    if (selectedVersion && selectedVersion === "pro") {
                                        window.open('https://moonlit-ceiling-277120.wl.r.appspot.com/')
                                    } else {
                                        window.open('https://acumenvelocity-ath-public.uc.r.appspot.com/')
                                    }
                                }}
                                disabled={!selectedVersion}
                            >
                                Continue
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};
